export enum BlockEditButtonContext {
  TITLE_CHANGE = 'title_change',
  API_KEY_CHANGE = 'api_key_change',
  GROUP_ALIAS_CHANGE = 'group_alias_change',
}
